export enum SurveyResponseSource {
  WEB = 'Web',
}
